import permissionRouteGuard from '@/helpers/router/permissionRouteGuard'
import setMetaTagsFromRouter from '@/helpers/router/setMetaTagsFromRouter'
import token from '@/services/token'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  const authStore = useAuthStore()
  const { isLogged, user } = storeToRefs(authStore)

  // check if token is valid on first enter
  if (from.name === null) {
    authStore.clearUserOnInvalidToken()
  }
  const isLoggedAndTokenValid: boolean = isLogged.value && token.isTokenValid()
  // block login page for logged users
  if (to.name === 'Login' && isLoggedAndTokenValid) {
    return next({ name: from.name || 'Home', query: from.query })
  }

  // action if route require auth
  if (to.matched.some((record) => record.meta.requireAuth === true)) {
    if (isLoggedAndTokenValid) {
      // check permission for logged user
      const permissionGuard = permissionRouteGuard(to, from, next, user.value)
      if (permissionGuard !== false) {
        return permissionGuard
      }
      return setMetaTagsFromRouter(to, from, next)
    }
    return next({ name: 'Login', query: { previous: to.path } })
  }

  return setMetaTagsFromRouter(to, from, next)
}
